import { render, staticRenderFns } from "./switchPlatform.vue?vue&type=template&id=1ad09c3f&scoped=true"
import script from "./switchPlatform.vue?vue&type=script&lang=js"
export * from "./switchPlatform.vue?vue&type=script&lang=js"
import style0 from "./switchPlatform.vue?vue&type=style&index=0&id=1ad09c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad09c3f",
  null
  
)

export default component.exports